module.exports = __webpack_public_path__ + "static/media/art2.185f8eda.png";